import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationLibraryService } from '../../services/navigation/navigation.service';

export interface ButtonMessageDialogData {
  title?: string;
  message: string;
  buttonMessage: string;
  buttonIcon: string;
  customClass?: string;
}

@Component({
  selector: 'app-button-message',
  templateUrl: './button-message.component.html',
  styleUrls: ['./button-message.component.scss'],
})
export class ButtonMessageComponent {
  constructor(
    public dialogRef: MatDialogRef<ButtonMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ButtonMessageDialogData,
    private readonly navService: NavigationLibraryService
  ) {}

  AfterViewInit() {
    this.navService.focusContainer('button-modal-container', true);
  }

  onActionProceed(): void {
    this.dialogRef.close(true);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
